import moment from 'moment'

const CHANGE_FILTER = 'realhub/admin/bookingFilters/CHANGE_FILTER'
const CHANGE_MULTIPLE_FILTERS = 'realhub/admin/bookingFilters/CHANGE_MULTIPLE_FILTERS'

// Initial State
const initialState = {
  currentMonth: moment(),
  dashboardView: 'locations',
  filterServiceId: 'all',
  filterString: '',
  filterUserId: 'all',
  rightSidebarMode: 'create',
  selectedDate: moment().startOf('day'),
  showRightSidebar: false,
}

// Actions
export function changeFilter(name, value){
  return {
    type: CHANGE_FILTER,
    name,
    value,
  }
}

export function changeMultipleFilters(filters = {}){
  return {
    type: CHANGE_MULTIPLE_FILTERS,
    filters,
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type } = action

  switch (type){
    case CHANGE_FILTER:
      return {
        ...state,
        ...{
          [action.name]: action.value,
        },
      }
    case CHANGE_MULTIPLE_FILTERS:
      return {
        ...state,
        ...action.filters,
      }
    default:
      return state
  }
}
